/* global wpcf7, Modernizr */

import Chocolat from 'chocolat'
import AOS from 'aos'
import { lazySelector } from './once'
import Swiper, { Lazy, Autoplay, Navigation } from 'swiper'
import mixitup from 'mixitup'

import init from '../cf7/init';
import submit from '../cf7/submit';
import reset from '../cf7/reset';
import validate from '../cf7/validate';


Swiper.use([ Lazy, Autoplay, Navigation ]);



export default {

    sliderGallery() {
        const elem = $('.slider-gallery-section')
        if(elem.find('.swiper-slide').length > 1) {
            const sliderHome = new Swiper(elem[0], {
                speed: 1000,
                spaceBetween: 0,
                slidesPerView: 1,
                lazy: {
                    loadPrevNext: true,
                },
                autoplay: {
                    delay: 3800,
                    disableOnInteraction: false,
                },
                loop: true,
                autoHeight: true,
            })
        }

    },
    sliderCaseStudies() {
        const elem = $('.case-studies').find('.swiper-container')
        if(elem.length) {

            const sliderHome = new Swiper(elem[0], {
                speed: 1000,
                spaceBetween: 0,
                lazy: {
                    loadPrevNext: true,
                },
                navigation: {
                    nextEl: elem.find('.arrow-right')[0],
                    prevEl: elem.find('.arrow-left')[0],
                },
                loop: true,
            })

        }
    },
    filteringLoad() {
        if($('.filtering-container').length){
            mixitup('.filtering-container', {
                selectors: {
                    target: '.filter-item',
                },
                animation: {
                    duration: 300,
                },
            })
        }
    },
    sliderProduct() {

        const elem = $('.slider-product-container')
        if(elem.length && elem.find('.swiper-slide').length > 1) {

            const sliderHome = new Swiper(elem.find('.swiper-container')[0], {
                speed: 1000,
                spaceBetween: 100,
                slidesPerView: 1,
                autoplay: {
                    delay: 5000,
                },
                navigation: {
                    nextEl: elem.find('.arrow-right')[0],
                    prevEl: elem.find('.arrow-left')[0],
                },
            })

        }

    },
    modaalsLoad(){
        // let searchOpened = false
        let videoOpened = false

        $('.video-embed-link').modaal({
            type: 'video',
            after_open: () =>{
                videoOpened = true
            },
            after_close: () => {
                videoOpened = false
            },
        })
        $(document.body).keyup(function(e) {
          // if (e.keyCode === 27 && searchOpened){
          //   $('.search-btn').modaal('close')
          // }
          if (e.keyCode === 27 && videoOpened){
            $('.video-player').modaal('close')
          }
        })

        $('.button-enquire').modaal()


    },
    testingIE() {

      if ( ! Modernizr.objectfit ) {

        $('.object-fix').each(function(){
            const item = this
            const img = item.getElementsByTagName('img')
            if(img.length){
                const imgUrl = img[0].getAttribute('data-src')
                if (imgUrl) {
                  item.style.backgroundImage = 'url(' + imgUrl + ')'
                  $(item).addClass('compat-object-fit')
                } else {
                    const imgUrlSrc = img[0].getAttribute('src')
                    if(imgUrlSrc){
                        item.style.backgroundImage = 'url(' + imgUrlSrc + ')'
                        $(item).addClass('compat-object-fit')
                    }

                }
            }
        })


      }

    },
    scrollDown() {
        $(document.body).on('click', '.scroll-first-section', function(e){
            e.preventDefault()
            $('html, body').animate({
                scrollTop: $('[data-first-section]').offset().top -80
            }, 800);
        })
    },
    contactForm(){

        if ( typeof wpcf7 === 'undefined' ) {
            console.error( "wpcf7 is not defined." );
            return;
        }

        if ( typeof wpcf7.api === 'undefined' ) {
            console.error( "wpcf7.api is not defined." );
            return;
        }

        if ( typeof window.fetch !== 'function' ) {
            console.error( "Your browser does not support window.fetch()." );
            return;
        }

        if ( typeof window.FormData !== 'function' ) {
            console.error( "Your browser does not support window.FormData()." );
            return;
        }

        if ( typeof NodeList.prototype.forEach !== 'function' ) {
            console.error( "Your browser does not support NodeList.forEach()." );
            return;
        }

        if ( typeof String.prototype.replaceAll !== 'function' ) {
            console.error( "Your browser does not support String.replaceAll()." );
            return;
        }


        wpcf7 = {
            init,
            submit,
            reset,
            validate,
            ...( wpcf7 ?? {} ),
        };
        document.querySelectorAll(
            '.wpcf7 > form'
        ).forEach( form => {
            wpcf7.init( form );
            form.closest( '.wpcf7' ).classList.replace( 'no-js', 'js' );
        } );

    },
    galleryLoad() {
        if($('.chocolat-image').length){
            Chocolat(document.querySelectorAll('.chocolat-image'), {
                loop: true,
            })
        }
    },

    testingIE() {

      if ( ! Modernizr.objectfit ) {

        $('.object-fix').each(function(){
            const item = this
            const img = item.getElementsByTagName('img')
            if(img.length){
                const imgUrl = img[0].getAttribute('data-src')
                if (imgUrl) {
                  item.style.backgroundImage = 'url(' + imgUrl + ')'
                  $(item).addClass('compat-object-fit')
                } else {
                    const imgUrlSrc = img[0].getAttribute('src')
                    if(imgUrlSrc){
                        item.style.backgroundImage = 'url(' + imgUrlSrc + ')'
                        $(item).addClass('compat-object-fit')
                    }

                }
            }
        })


      }

    },
    lazyLoadRefresh() {
        if (lazySelector) {
            lazySelector.update()
        }
    },
	animationsRefresh(){
		AOS.refresh()
	},
    init() {
        this.galleryLoad()
        this.lazyLoadRefresh()
        this.testingIE()
        this.scrollDown()
        this.testingIE()
        // $.ajax({
        //     url: "http://shop.shorts-lifts.co.uk/rest/V1/customers/me",
        //     type: "GET",
        //     error: function(e) {
        //         console.log("TESTING ERROR", e);
        //         ///createGuestCart();
        //     },
        //     success: function(resp) {
        //         console.log("testing response", resp.id);
        //         //getCart(resp.id);
        //     }
        // });
        // function createGuestCart() {
        //     const url = "http://shop.shorts-lifts.co.uk/rest/V1/guest-carts";
        //     $.ajax({
        //         url: url,
        //         type: "POST",
        //         success: function(resp) {
        //             console.log("got guest cart", resp);
        //         },
        //         error: function(error) {
        //             console.log("error in creating guest cart", e);
        //         }
        //     });
        // }
        // function getCart(customerId) {
            // const url = "http://shop.shorts-lifts.co.uk/rest/V1/carts/mine?customer_id=dlkjgs7ev5uggj4rec1825ubc3";
            // $.ajax({
            //     url: url,
            //     type: "GET",
            //     error: function(e) {
            //         console.log("TESTING ERROR", e);
            //     },
            //     success: function(resp) {
            //         console.log("testing cart data", resp);
            //     }
            // });
        // }





    },
    finalize() {
        this.contactForm()
        this.animationsRefresh()
        this.sliderProduct()
        this.sliderCaseStudies()
        this.filteringLoad()
        this.sliderGallery()
        this.modaalsLoad()
    },
}
